// This file is generated by a script. Do not edit this file directly.
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from 'react';
export var Sidebar = function Sidebar(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 20 20"
  }, props), /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M2.5 2.5c-.691 0-1.25.559-1.25 1.25v12.5c0 .691.559 1.25 1.25 1.25h8.75v-15zm15 0h-5v15h5c.691 0 1.25-.559 1.25-1.25V3.75c0-.691-.559-1.25-1.25-1.25m0-1.25c1.379 0 2.5 1.121 2.5 2.5v12.5c0 1.379-1.121 2.5-2.5 2.5h-15a2.5 2.5 0 0 1-2.5-2.5V3.75c0-1.379 1.121-2.5 2.5-2.5z"
  }));
};
